import { CHANNELS } from "@/content/thoratech";
import {
  Phone,
  Mail,
  MessageCircle,
  MessageSquare,
  Video,
  PhoneCall,
  Hash,
  Bot,
} from "lucide-react";

const ICONS = {
  phone: Phone,
  mail: Mail,
  whatsapp: MessageCircle,
  chat: MessageSquare,
  video: Video,
  ivr: PhoneCall,
  social: Hash,
  bot: Bot,
};

export default function Channels() {
  return (
    <section
      id="channels"
      data-testid="channels-section"
      className="relative py-24 md:py-32 bg-white border-t border-[#01080E]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-3 mb-5">
              <span className="block h-px w-8 bg-[#2AC0A5]" />
              <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#01080E]">
                How we connect with your customers
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold leading-[1.05] text-[#01080E]">
              Every channel your customers use,
              <br />
              <span className="text-[#2AC0A5]">handled under one operation.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg text-[#01080E]/75 leading-relaxed">
              Trained agents, scripts, QA and real-time monitoring across voice, messaging, video and
              AI. We turn fragmented contact into a single, governed conversation.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#01080E]/10 border border-[#01080E]/10">
          {CHANNELS.map((c) => {
            const Icon = ICONS[c.icon];
            return (
              <div
                key={c.name}
                data-testid={`channel-${c.icon}`}
                className="group bg-white p-6 md:p-7 hover:bg-[#01080E] transition-colors duration-300"
              >
                <span className="inline-flex items-center justify-center w-11 h-11 bg-[#2AC0A5]/15 text-[#01080E] group-hover:bg-[#2AC0A5] transition-colors">
                  <Icon size={20} />
                </span>
                <h3 className="mt-5 font-display text-lg md:text-xl font-semibold text-[#01080E] group-hover:text-white transition-colors">
                  {c.name}
                </h3>
                <p className="mt-2 text-sm text-[#01080E]/65 group-hover:text-white/75 leading-relaxed transition-colors">
                  {c.detail}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
